import {RouterModule, Routes } from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import { InicioComponent } from './components/home/inicio.component';
import { LoginComponent } from './login/login.component';
import { RecuperarClaveComponent } from './components/recuperar-clave/recuperar-clave.component';
import { ReestablecerClaveComponent } from './components/recuperar-clave/reestablecer-clave.component';


const APP_ROUTES: Routes = [
    {path: 'login', component: LoginComponent},
    {path: 'recuperarclave', component: RecuperarClaveComponent},
    {path: 'recuperarclave/:id', component: ReestablecerClaveComponent},
    {path: 'home', component: HomeComponent,
     children: [
      {
        path: '',
        component: InicioComponent,
        data: {
          title: 'Movimientos Bancarios'
        }
      },
      {
        path: 'acciones',
        //loadChildren: () => import('./components/components.module').then(mod => mod.ComponentsModule),
        loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule)
      }
    ]
  },
    {path: '', redirectTo: '/login', pathMatch: 'full' }
  ];

    export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, {useHash: true});
